import React from 'react'
import NewHeader from '../components/NewHeader'
import Footer from '../components/footer'
import WhyChooseUs from '../components/whychooseus'
import AboutSection from '../components/AboutSection'
import BannerSection from '../components/BannerSection'
import ServicesPage from '../components/ourservices'
import DownloadAppSection from '../components/downloadbanner'

export default function Homepage() {
  return (
    <>
      <NewHeader />
      <WhyChooseUs />
      <AboutSection />
      <ServicesPage />
      <BannerSection />
      <DownloadAppSection />
      <Footer />
    </>
  )
}
